<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
    ></search-form>
    <a-modal
      width="700px"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :keyboard="false"
      class="action-form-model"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
        :taskId="task_id"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'type_id'">
          {{
            codeToText(record.vehicleRegistration?.type_id, Enum.carModel.value)
          }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record.vehicleRegistration?.begin_time }} 至
          {{ record.vehicleRegistration?.end_time }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{
            codeToText(
              record.vehicleRegistration?.visit_area,
              Enum.areaType.value
            )
          }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.vehicleRegistration?.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{ codeToText(record.vehicleRegistration?.create_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableCheck && record.state == 0"
            >
              审核
            </a-button>
          </span>
          <span>
            <a-button
              @click="showAmendModal(record)"
              :loading="loadingRecord === record"
              v-if="record.isUpdateAmend"
            >
              编辑来访日期
            </a-button>
          </span>
        </template>
      </template>
    </a-table>

    <a-modal
      v-model:open="amendOpen"
      title="编辑来访日期"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <amend
        :v-if="amendOpen"
        @submit="clickOk"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></amend>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import {
  getData,
  revoke,
  checkUpdateField
} from '@/api/car_application/car_registration_approval'
import {
  getDetail,
} from '@/api/car_application/car_registration_history'
import action from './action'
import amend from './action/amend'
import { message } from 'ant-design-vue'
import searchForm from '@/components/search_form'
import { codeToText, constantToOptions } from '@/utils/format'
import { approvalOperation } from '@/utils/common'
import dayjs from 'dayjs'
//初始化
const pageName = '车辆备案审核'
const idField = 'ref_id' //响应数据的id的字段名
const store = useStore()
const Enum = toRefs(store.state.common)
const refreshTimer = ref(null)

// 获取当前登录角色的申请园区visit_area
const defaultVisitArea = computed(() => {
  const depart = store.getters['user/depart']
  return depart?.visit_area || ''
})

const permissionList = computed(() => store.getters['user/permissionList'])
const ableSearch = computed(() =>
  !!permissionList.value?.find(item => item.code === 'carRegistrationApproval:list')
)
const ableCheck = computed(() =>
  !!permissionList.value?.find(item => item.code === 'carRegistrationApproval:check')
)

//1、搜索框
const formCollection = [
  {
    type: 'input',
    field: 'applicationNumber',
    label: '受理单号',
  },
  {
    type: 'input',
    field: 'licensePlate',
    label: '车牌号码',
  },
  {
    type: 'input',
    field: 'visitorCompany',
    label: '来访单位',
  },
  {
    type: 'select',
    field: 'visitArea',
    storeOptions: 'areaType',
    defaultValue: [1, 2].includes(defaultVisitArea.value) ? defaultVisitArea.value : '',
    label: '备案园区',
    width: '160px',
    'allow-clear': true,
  },
  {
    type: 'dateRange',
    startField: 'beginTime',
    endField: 'endTime',
    // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
    // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
    label: '时间范围',
    'allow-clear': true,
  },
]

// 从store获取缓存的搜索条件
const cachedSearchParams = computed(() => store.state.search.searchCarRegApproval)

// 组件挂载时恢复搜索条件
// 设置自动刷新
const setupAutoRefresh = () => {
  // 清除旧定时器
  if (refreshTimer.value) {
    clearInterval(refreshTimer.value)
  }

  // 设置新定时器，每分钟刷新一次
  refreshTimer.value = setInterval(() => {
    // 仅在审核窗口未打开时刷新
    if (!open.value && !amendOpen.value) {
      fetch()
    }
  }, 60000)
}

onMounted(() => {
  for (const key in cachedSearchParams.value) {
    searchFormRef.value.formState[key] = cachedSearchParams.value[key]
  }
  fetch()
  setupAutoRefresh()
})

onUnmounted(() => {
  // 清除定时器避免内存泄漏
  if (refreshTimer.value) {
    clearInterval(refreshTimer.value)
  }
})

const searchFormRef = ref()
function handelSearch() {
  pagination.value.current = 1
  fetch()
  // 搜索时更新缓存
  const params = {
    ...searchFormRef.value.formState
  }
  store.commit('search/setCarRegApproval', params)
}

//2、表格
const columns = [
  {
    title: '序号',
    dataIndex: 'rowIndex',
    key: 'rowIndex',
    align: 'center',
    width: 50,
    fixed: 'left',
  },
  {
    title: '受理单号',
    dataIndex: 'application_number',
    key: 'application_number',
    dataInObject: 'vehicleRegistration',
    align: 'left',
  },
  {
    title: '园区类型',
    dataIndex: 'visit_area',
    key: 'visit_area',
    align: 'left',
  },
  {
    title: '来访单位',
    dataIndex: 'visitor_company',
    key: 'visitor_company',
    dataInObject: 'vehicleRegistration',
    align: 'left',
    width: 180,
  },
  {
    title: '车牌颜色',
    dataIndex: 'license_plate_color',
    key: 'license_plate_color',
    dataInObject: 'vehicleRegistration',
    align: 'left',
  },
  {
    title: '车牌号码',
    dataIndex: 'license_plate',
    key: 'license_plate',
    dataInObject: 'vehicleRegistration',
    align: 'left',
  },
  {
    title: '手机号码',
    dataIndex: 'phone',
    key: 'phone',
    dataInObject: 'vehicleRegistration',
    align: 'left',
  },
  {
    title: '备案时间范围',
    key: 'time_range',
    align: 'left',
  },
  {
    title: '审核状态',
    dataIndex: 'state',
    key: 'state',
    align: 'left',
    width: 130,
  },
  {
    title: '提交人',
    // dataIndex: 'create_user_id',
    key: 'create_user_id',
    dataInObject: 'vehicleRegistration',
    align: 'left',
  },
  {
    title: '提交审核时间',
    dataIndex: 'submit_time',
    key: 'submit_time',
    align: 'left',
    dataInObject: 'vehicleRegistration',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    align: 'left',
    fixed: 'right',
    // width: '120px',
  },
]

const tableData = ref([])
const loading = ref(false)
const loadingRecord = ref()
const pagination = ref({
  current: 1,
  pageSize: 10,
  showLessItems: true,
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total, range) => {
    return `共 ${total} 条`
  },
})

function handleTableChange(page) {
  pagination.value = { ...pagination.value, ...page }
  fetch()
}

const handleRow = (record) => {
  return {
    ondblclick: (event) => {
      event.stopPropagation();
      showEditModal(record);
    }
  }
}

function fetch() {
  //获取表单值
  const formState = searchFormRef.value?.formState

  loading.value = true

  getData({
    size: pagination.value.pageSize,
    pn: pagination.value.current,
    ...formState,
  }).then(({ data }) => {
    loading.value = false
    tableData.value = data.list
    for (let i = 0; i < tableData.value.length; i++) {
      checkIsUpdateField({
        id: tableData.value[i].ref_id,
        process_instance_id: tableData.value[i].process_instance_id
      }).then(res => {
        tableData.value[i].isUpdateAmend = res
      })
    }
    pagination.value.total = data.total

    if (data.total > 0 && data.list.length === 0 && pagination.value.current > 1) {
      pagination.value.current -= 1;
      fetch()
    }
  })
}

const checkIsUpdateField = async (data) => {
  const res = await checkUpdateField(data)
  return res.data
}
const amendOpen = ref(false)
const showAmendModal = async (data) => {
  loadingRecord.value = data
  const detail = await getDetail({id: data[idField]})
  loadingRecord.value = null

  if (detail.data) {
    editData.value = {
      ...detail.data,
      [idField]: data[idField],
      process_task_id: data.process_task_id,
    }
    console.log(editData.value,'ee')
    amendOpen.value = true
  }
}

//3、审核
const open = ref(false)
const isEdit = ref(true)
const editData = ref(null)
const task_id = ref(null)
const showEditModal = async (data) => {
  try {
    task_id.value = data.process_task_id;
    const res = await getDetail({ id: data[idField] });
    editData.value = res.data;
  } catch (error) {
    message.error('获取备案车辆信息失败');
  }
  open.value = true;
}

function clickOk() {
  fetch()
  handleOk()
  clearEditData()
}

const handleOk = () => {
  open.value = false
  amendOpen.value = false
}
const clearEditData = () => {
  editData.value = null
}

//4、撤销审核
async function delRow(data) {
  const res = await revoke({ id: data[idField] })
  if (res.success) {
    message.success('撤销审核成功！')
    fetch()
  } else {
    message.warn('撤销审核失败' + res.message)
  }
}
</script>
